import { useEffect } from 'react';
import type { SurrenderSettingsResponse } from 'src/apis/surrender-service/types';
import type { SurrenderRootRequest } from 'src/apis/surrender-service/use-surrender-root';
import { useAxios, type Successful } from 'src/hooks/use-axios';

type HookConfig = {
  surrenderRoot: Successful<SurrenderRootRequest>;
};

type ExecuteProps = {
  url: string;
};

export function useSurrenderSettings({ surrenderRoot }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) => {
      return axios.request<SurrenderSettingsResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!surrenderRoot.response.data._links.getSettings) return;

    const url = surrenderRoot.response.data._links.getSettings.href;

    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [surrenderRoot.response]);

  if (!surrenderRoot.response.data._links.getSettings) return;

  return request;
}

export type SurrenderSettingsRequest = ReturnType<typeof useSurrenderSettings>;
